/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import teamPhoto from '../images/home/teamPhoto.png';

const Card = ({ data }) => {
  const [isHover, setIsHover] = React.useState(false);

  return (
    <div
      className="mb-6 w-36 h-36 md:w-52 md:h-52 2xl:w-72 2xl:h-72 relative"
      onMouseOver={() => {
        setIsHover(true);
      }}
      onMouseOut={() => {
        setIsHover(false);
      }}
    >
      {/* when profile picture is uploaded, change {teamPhoto} to {data.picture} */}
      <img src={teamPhoto} alt="profile" />
      <div
        className={`absolute bottom-0 bg-gradient-to-b from-enterpriseOrange-500 to-enterpriseOrange-800 p-2 mb-2 container overlay text-left text-white rounded-lg leading-7 opacity-90 transition-height duration-300 ease-in-out ${
          isHover
            ? 'h-19 md:h-25 lg:h-25 2xl:h-28'
            : 'h-11 md:h-14 lg:h-16 2xl:h-20'
        } `}
      >
        <div className="text-xs md:text-base 2xl:text-2xl uppercase font-bold">
          {data.firstName}
        </div>
        <div className="text-xs md:text-base 2xl:text-2xl uppercase font-bold">
          {data.lastName}
        </div>
        <div
          className={`text-xs md:text-sm 2xl:text-base italic transition-opacity ${
            isHover ? 'opacity-90' : 'opacity-0'
          } `}
        >
          {data.title}
        </div>
      </div>
    </div>
  );
};

export default Card;
